import { render } from "./AppHeader.vue?vue&type=template&id=5ecf8a7e&scoped=true"
import script from "./AppHeader.vue?vue&type=script&lang=js"
export * from "./AppHeader.vue?vue&type=script&lang=js"

import "./AppHeader.vue?vue&type=style&index=0&id=5ecf8a7e&lang=scss"
import "./AppHeader.vue?vue&type=style&index=1&id=5ecf8a7e&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ecf8a7e"]])

export default __exports__
import QBadge from 'quasar/src/components/badge/QBadge.js';
import QScrollArea from 'quasar/src/components/scroll-area/QScrollArea.js';
import QDrawer from 'quasar/src/components/drawer/QDrawer.js';
import QField from 'quasar/src/components/field/QField.js';
import QItem from 'quasar/src/components/item/QItem.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QBtnDropdown from 'quasar/src/components/btn-dropdown/QBtnDropdown.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QBadge,QScrollArea,QDrawer,QField,QItem,QBtn,QBtnDropdown});
